import React from "react";
import Avatar from "antd/es/avatar/index";
import Icon from "antd/es/icon/index";
import TextInput from "./Components/TextInput";
import HeaderText from "./Components/HeaderText";
import RevealText from "./Components/RevealText";
import ExampleText from "./Components/ExampleText/ExampleText";
import AnnotatedText from "./Components/AnnotatedText";
import SubtitleText from "./Components/SubtitleText";
import FillBlankText from "./Components/FillBlankText/FillBlankText";
import SelectBlankText from "./Components/SelectBlankText/SelectBlankText";
import RearrangeText from "./Components/RearrangeText";
import Image from "./Components/Image";
import RevealImage from "./Components/RevealImage";
import ImageSlideShow from "./Components/ImageSlideShow";
import QuizMenu from "./Components/QuizMenu";
import Label from "./Components/Label";
import NotificationWindow from "./Components/NotificationWindow";
import Divider from "./Components/Divider";
import Select from "./Components/Select";
import TextSwitcher from "./Components/TextSwitcher";
import Tags from "./Components/Tags";
import Checkboxes from "./Components/Checkboxes";
import RadioButtons from "./Components/RadioButtons";
import NumberInput from "./Components/NumberInput";
import MultiLineInput from "./Components/MultiLineInput";
import Rate from "./Components/Rate";
import DatePicker from "./Components/DatePicker";
import MultiChoiceGrid from "./Components/MultiChoice/MultiChoiceGrid";
import MultiChoiceRow from "./Components/MultiChoice/MultiChoiceRow";
import MultiChoiceCol from "./Components/MultiChoice/MultiChoiceCol";
import Audio from "./Components/Audio";
import FinishPage from "./Components/FinishPage";

import radioButtonIcon from "./CustomIcons/radiobuttonicon";
import headerIcon from "./CustomIcons/headericon";
import inputIcon from "./CustomIcons/inputIcon";
import numberInputIcon from "./CustomIcons/numberInputIcon";
import multiLineInputIcon from "./CustomIcons/multiLineInputIcon";

function _defaultItems() {
  // deafult sample question
  const questions = {
    en: "Sample question ?",
    // pt: "Pergunta exemplo ?"
  };

  const options = [
    {
      value: "1",
      text: { ...questions }
    },
    {
      value: "2",
      text: { ...questions }
    }
  ];

  return [
    {
      key: "MultiChoiceGrid",
      name: "toolbox.multichoicegrid.name", // id of translation
      questions,
      mediaFiles: (
        Array(4)
        .fill(undefined)
        .map(()=>{return new Object({
          title: "sample image",
          src: "https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png",
          is_answer: false,
          show_title: false,
          file: undefined,
        })})
      ),
      response: -1,
      // description: "toolbox.textInput.description", // desciption under input on toolbox
      icon: <Avatar icon="appstore" />, // this will go to Dom so can be string|| jsx component
      field_name: "multichoicegrid_", // will add a generated uuidv4
      Component: MultiChoiceGrid // component not instanciated
    },
    {
      key: "MultiChoiceRow",
      name: "toolbox.multichoicerow.name", // id of translation
      questions,
      mediaFiles: (
        Array(5)
        .fill(undefined)
        .map(()=>{return new Object({
          title: "sample image",
          src: "https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png",
          is_answer: false,
          is_inside: false,
          file: undefined,
        })})
      ),
      response: -1,
      // description: "toolbox.textInput.description", // desciption under input on toolbox
      icon: <Avatar icon="dash" />, // this will go to Dom so can be string|| jsx component
      field_name: "multichoicerow_", // will add a generated uuidv4
      Component: MultiChoiceRow // component not instanciated
    },
    {
      key: "MultiChoiceCol",
      name: "toolbox.multichoicecol.name", // id of translation
      questions,
      mediaFiles: (
        Array(5)
        .fill(undefined)
        .map(()=>{return new Object({
          title: "sample image",
          src: "https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png",
          is_answer: false,
          is_inside: false,
          file: undefined,
        })})
      ),
      response: -1,
      // description: "toolbox.textInput.description", // desciption under input on toolbox
      icon: <Avatar icon="menu" />, // this will go to Dom so can be string|| jsx component
      field_name: "multichoicecol_", // will add a generated uuidv4
      Component: MultiChoiceCol // component not instanciated
    },
    {
      key: "Audio",
      name: "toolbox.audio.name", // id of translation
      questions,
      mediaFiles: (
        Array(1)
        .fill(undefined)
        .map(()=>{return new Object({
          title: "sample audio",
          src: "https://silkmandarinedu.com/wp-content/uploads/2018/05/Listening-2-hsk1-1.mp3?_=1",
          is_answer: false,
          file: undefined,
        })})
      ),
      // description: "toolbox.textInput.description", // desciption under input on toolbox
      icon: (
        <Avatar>
          <Icon type="audio" />
        </Avatar>
      ), // this will go to Dom so can be string|| jsx component
      field_name: "audio_", // will add a generated uuidv4
      Component: Audio // component not instanciated
    },
    {
      key: "HeaderText",
      name: "toolbox.headertext.name", // id of translation
      questions,
      // description: "toolbox.headertext.description", // desciption under input on toolbox
      icon: (
        <Avatar>
          <Icon component={headerIcon} />
        </Avatar>
      ), // this will go to Dom so can be string|| jsx component
      field_name: "header_text_", // will add a generated uuidv4
      Component: HeaderText // component not instanciated
    },
    {
      key: "RevealText",
      name: "toolbox.revealtext.name", // id of translation
      questions,
      // description: "toolbox.revealtext.description", // desciption under input on toolbox
      icon: (
        <Avatar>
          <Icon type="eye-invisible" />
        </Avatar>
      ), // this will go to Dom so can be string|| jsx component
      field_name: "body_text_", // will add a generated uuidv4
      Component: RevealText // component not instanciated
    },
    {
      key: "ExampleText",
      name: "toolbox.exampletext.name", // id of translation
      questions,
      // description: "toolbox.exampletext.description", // desciption under input on toolbox
      icon: (
        <Avatar>
          <Icon type="align-center" />
        </Avatar>
      ), // this will go to Dom so can be string|| jsx component
      field_name: "example_text_", // will add a generated uuidv4
      Component: ExampleText // component not instanciated
    },
    {
      key: "SubtitleText",
      name: "toolbox.subtitletext.name", // id of translation
      questions,
      // description: "toolbox.subtitletext.description", // desciption under input on toolbox
      icon: (
        <Avatar>
          <Icon type="strikethrough" />
        </Avatar>
      ), // this will go to Dom so can be string|| jsx component
      field_name: "subtitle_text_", // will add a generated uuidv4
      Component: SubtitleText // component not instanciated
    },
    {
      key: "AnnotatedText",
      name: "toolbox.annotatedtext.name", // id of translation
      questions,
      // description: "toolbox.annotatedtext.description", // desciption under input on toolbox
      icon: (
        <Avatar>
          <Icon type="sort-descending" />
        </Avatar>
      ), // this will go to Dom so can be string|| jsx component
      field_name: "annotated_text_", // will add a generated uuidv4
      Component: AnnotatedText // component not instanciated
    },
    {
      key: "FillBlankText",
      name: "toolbox.fillblanktext.name", // id of translation
      questions,
      sentences: {
        syntaxConfig: true,
        blanks: [
          { answer: "" },
        ],
        en: [
          { hanzi: ["这个", "椅子", -1], pinyin: ["Zhège", "yĭzi", -1], blank: [null, null, "多小钱/duoxiaoqian"] },
          { hanzi: ["七十", "块"], pinyin: ["Qīshí", "kuài"], blank: [] },
        ],
        correctAnswers: { hanzi: [null, null, "多小钱"], pinyin: [null, null, "duoxiaoqian"] },
      },
      response: -1,
      // description: "toolbox.fillblanktext.description", // desciption under input on toolbox
      icon: (
        <Avatar>
          <Icon type="dash" />
        </Avatar>
      ), // this will go to Dom so can be string|| jsx component
      field_name: "fill_blank_text_", // will add a generated uuidv4
      Component: FillBlankText // component not instanciated
    },
    {
      key: "SelectBlankText",
      name: "toolbox.selectblanktext.name", // id of translation
      questions,
      options: {
        en: [
          { value: '不但能看到一群群小鱼在河里游来游去。', is_answer: false, select: 1 },
          { value: '这儿的河水非常干净，站在河边。', is_answer: false, select: 1 },
          { value: '还能看到河底绿绿的水草。', is_answer: false, select: 1 },
        ],
      },
      response: -1,
      // description: "toolbox.selectblanktext.description", // desciption under input on toolbox
      icon: (
        <Avatar>
          <Icon type="border-bottom" />
        </Avatar>
      ), // this will go to Dom so can be string|| jsx component
      field_name: "select_blank_text_", // will add a generated uuidv4
      Component: SelectBlankText // component not instanciated
    },
    {
      key: "RearrangeText",
      name: "toolbox.rearrangetext.name", // id of translation
      questions,
      disarrangedText: {
        disarranged: {hanzi: "下午 明天 什么 做 想 你", pinyin: "xiawu mingtian shenme zuo xiang ni"},
        arranged: [
          {hanzi: "你 想 明天 下午 做 什么", pinyin: "ni xiang mingtian xiawu zuo shenme"},
          {hanzi: "明天 下午 你 想 做 什么", pinyin: "mingtian xiawu ni xiang zuo shenme"},
        ],
      },
      response: -1,
      // description: "toolbox.rearrangetext.description", // desciption under input on toolbox
      icon: (
        <Avatar>
          <Icon type="interaction" />
        </Avatar>
      ), // this will go to Dom so can be string|| jsx component
      field_name: "rearrange_text", // will add a generated uuidv4
      Component: RearrangeText // component not instanciated
    },
    {
      key: "Image",
      name: "toolbox.image.name", // id of translation
      questions,
      mediaFiles: (
        Array(1)
        .fill(undefined)
        .map(()=>{return new Object({
          title: "sample image",
          src: "https://silkmandarinedu.com/wp-content/uploads/2018/05/WeChat-Image_20180423150222.png",
          is_answer: false,
          file: undefined,
        })})
      ),
      // description: "toolbox.image.description", // desciption under input on toolbox
      icon: (
        <Avatar>
          <Icon type="picture" />
        </Avatar>
      ), // this will go to Dom so can be string|| jsx component
      field_name: "image_", // will add a generated uuidv4
      Component: Image // component not instanciated
    },
    {
      key: "RevealImage",
      name: "toolbox.revealimage.name", // id of translation
      questions,
      mediaFiles: (
        Array(1)
        .fill(undefined)
        .map(()=>{return new Object({
          title: "sample Revealimage",
          src: "https://silkmandarinedu.com/wp-content/uploads/2018/05/WeChat-Image_20180423150222.png",
          is_answer: false,
          file: undefined,
        })})
      ),
      // description: "toolbox.revealimage.description", // desciption under input on toolbox
      icon: (
        <Avatar>
          <Icon type="eye-invisible" />
          <Icon type="picture" />
        </Avatar>
      ), // this will go to Dom so can be string|| jsx component
      field_name: "reveal_image_", // will add a generated uuidv4
      Component: RevealImage // component not instanciated
    },
    {
      key: "ImageSlideShow",
      name: "toolbox.imageslideshow.name", // id of translation
      questions,
      mediaFiles: (
        Array(1)
        .fill(undefined)
        .map(()=>{return new Object({
          title: "sample image",
          src: "https://silkmandarinedu.com/wp-content/uploads/2018/05/WeChat-Image_20180423150222.png",
          is_answer: false,
          file: undefined,
        })})
      ),
      toolConfig: {
        slideOnCheckAnswer: true,
        showPrevNextBtns: false,
        loop: false,
      },
      // description: "toolbox.image.description", // desciption under input on toolbox
      icon: (
        <Avatar>
          <Icon type="pic-right" />
        </Avatar>
      ), // this will go to Dom so can be string|| jsx component
      field_name: "image_slide_show_", // will add a generated uuidv4
      Component: ImageSlideShow // component not instanciated
    },
    {
      key: "QuizMenu",
      name: "toolbox.quizmenu.name", // id of translation
      questions,
      options: [],
      // description: "toolbox.quizmenu.description", // desciption under input on toolbox
      icon: <Avatar icon="profile" />, // this will go to Dom so can be string|| jsx component
      field_name: "quiz_menu_", // will add a generated uuidv4
      Component: QuizMenu // component not instanciated
    },
    {
      key: "FinishPage",
      name: "toolbox.finishpage.name", // id of translation
      questions,
      mediaFiles: (
        Array(1)
        .fill(undefined)
        .map(()=>{return new Object({
          title: "sample FinishPage",
          src: "https://silkmandarinedu.com/wp-content/uploads/2018/05/Listening-2-hsk1-1.mp3?_=1",
          is_answer: false,
          file: undefined,
        })})
      ),
      toolConfig: {
        showScore: false,
      },
      // description: "toolbox.finishpage.description", // desciption under input on toolbox
      icon: (
        <Avatar>
          <Icon type="file-done" />
        </Avatar>
      ), // this will go to Dom so can be string|| jsx component
      field_name: "finish_page_", // will add a generated uuidv4
      Component: FinishPage // component not instanciated
    },
    {
      key: "LabelText",
      name: "toolbox.label.name", // id of translation
      questions,
      // description: "toolbox.label.description", // desciption under input on toolbox
      icon: <Avatar icon="font-colors" />, // this will go to Dom so can be string|| jsx component
      field_name: "label_", // will add a generated uuidv4
      Component: Label // component not instanciated
    },
    {
      key: "NotificationWindow",
      name: "toolbox.notificationwindow.name", // id of translation
      questions,
      // description: "toolbox.notificationwindow.description", // desciption under input on toolbox
      icon: <Avatar icon="alert" />, // this will go to Dom so can be string|| jsx component
      field_name: "notification_window_", // will add a generated uuidv4
      Component: NotificationWindow // component not instanciated
    },
    {
      key: "Divider",
      name: "toolbox.divider.name", // id of translation
      questions,
      // description: "toolbox.label.description", // desciption under input on toolbox
      icon: <Avatar icon="line" />, // this will go to Dom so can be string|| jsx component
      field_name: "divider_", // will add a generated uuidv4
      Component: Divider // component not instanciated
    },
    {
      key: "Select",
      name: "toolbox.select.name", // id of translation
      questions,
      options,
      response: -1,
      // description: "toolbox.label.description", // desciption under input on toolbox
      icon: <Avatar icon="down-square" />, // this will go to Dom so can be string|| jsx component
      field_name: "select_", // will add a generated uuidv4
      Component: Select // component not instanciated
    },
    {
      key: "TextSwitcher",
      name: "toolbox.textswitcher.name", // id of translation
      questions,
      options: [
        { value: 'a', text: { en: '不但能看到一群群小鱼在河里游来游去。' } },
        { value: 'b', text: { en: '这儿的河水非常干净，站在河边。' } },
        { value: 'c', text: { en: '还能看到河底绿绿的水草。' } }
      ],
      response: -1,
      // description: "toolbox.label.description", // desciption under input on toolbox
      icon: <Avatar icon="retweet" />, // this will go to Dom so can be string|| jsx component
      field_name: "text_switcher", // will add a generated uuidv4
      Component: TextSwitcher // component not instanciated
    },
    {
      key: "Tags",
      name: "toolbox.tags.name", // id of translation
      questions,
      options,
      // description: "toolbox.label.description", // desciption under input on toolbox
      icon: <Avatar icon="tags" />, // this will go to Dom so can be string|| jsx component
      field_name: "tags_", // will add a generated uuidv4
      Component: Tags // component not instanciated
    },
    {
      key: "Checkboxes",
      name: "toolbox.checkboxes.name", // id of translation
      questions,
      options,
      // description: "toolbox.label.description", // desciption under input on toolbox
      icon: <Avatar icon="check-circle" />, // this will go to Dom so can be string|| jsx component
      field_name: "checkboxes_", // will add a generated uuidv4
      Component: Checkboxes // component not instanciated
    },
    {
      key: "RadioButtons",
      name: "toolbox.radiobuttons.name", // id of translation
      questions,
      options,
      // description: "toolbox.label.description", // desciption under input on toolbox
      icon: (
        <Avatar>
          <Icon component={radioButtonIcon} />
        </Avatar>
      ), // this will go to Dom so can be string|| jsx component
      field_name: "radiobuttons_", // will add a generated uuidv4
      Component: RadioButtons // component not instanciated
    },
    {
      key: "TextInput",
      name: "toolbox.textinput.name", // id of translation
      questions,
      // description: "toolbox.textInput.description", // desciption under input on toolbox
      icon: (
        <Avatar>
          <Icon component={inputIcon} />
        </Avatar>
      ), // this will go to Dom so can be string|| jsx component
      field_name: "textinput_", // will add a generated uuidv4
      Component: TextInput // component not instanciated
    },
    {
      key: "NumberInput",
      name: "toolbox.numberinput.name", // id of translation
      questions,
      // description: "toolbox.textInput.description", // desciption under input on toolbox
      icon: (
        <Avatar>
          <Icon component={numberInputIcon} />
        </Avatar>
      ), // this will go to Dom so can be string|| jsx component
      field_name: "numberinput_", // will add a generated uuidv4
      Component: NumberInput // component not instanciated
    },
    {
      key: "MultiLineInput",
      name: "toolbox.multilineinput.name", // id of translation
      questions,
      response: -1,
      toolConfig: {
        minChars: 50,
      },
      // description: "toolbox.textInput.description", // desciption under input on toolbox
      icon: (
        <Avatar>
          <Icon component={multiLineInputIcon} />
        </Avatar>
      ), // this will go to Dom so can be string|| jsx component
      field_name: "multilineinput_", // will add a generated uuidv4
      Component: MultiLineInput // component not instanciated
    },
    {
      key: "Rate",
      name: "toolbox.rate.name", // id of translation
      questions,
      // description: "toolbox.textInput.description", // desciption under input on toolbox
      icon: <Avatar icon="star" />, // this will go to Dom so can be string|| jsx component
      field_name: "rate_", // will add a generated uuidv4
      Component: Rate // component not instanciated
    },
    {
      key: "DatePicker",
      name: "toolbox.datepicker.name", // id of translation
      questions,
      // description: "toolbox.textInput.description", // desciption under input on toolbox
      icon: <Avatar icon="calendar" />, // this will go to Dom so can be string|| jsx component
      field_name: "datepicker_", // will add a generated uuidv4
      Component: DatePicker // component not instanciated
    }
  ];
}

export default _defaultItems;
